// extracted by mini-css-extract-plugin
export default {"sidebar-header":"components-hotel-reviews-sidebar-module__sidebar-header","scrollable-container":"components-hotel-reviews-sidebar-module__scrollable-container"};